/**
 * batch-62 taken-ux (FO-464 §2.B.7) — pure beslisregels voor een swipe-actie op
 * een kaart: swipe naar rechts en loslaten voorbij de drempel = de actie
 * (bv. gereedmelden). React-vrij, zodat de regels zonder DOM getest worden en
 * de portal (monteur) en de mobiele backoffice precies hetzelfde gedrag hebben.
 */

/** Na zoveel pixels beweging beslissen we of het een swipe of scrollen is. */
export const SWIPE_RICHTING_DREMPEL_PX = 10
/** Deel van de kaartbreedte dat je moet vegen voordat loslaten de actie start. */
export const SWIPE_ACTIVEER_FRACTIE = 0.35
/** Ondergrens van die drempel, zodat een smalle kaart niet per ongeluk afgaat. */
export const SWIPE_ACTIVEER_MIN_PX = 96

export type SwipeAs = 'onbekend' | 'horizontaal' | 'verticaal'

/**
 * Bepaalt na de eerste beweging of het gebaar horizontaal (swipe) of verticaal
 * (scrollen) is. Onder de richting-drempel is het nog 'onbekend'.
 */
export function bepaalSwipeAs(dx: number, dy: number, drempel = SWIPE_RICHTING_DREMPEL_PX): SwipeAs {
  if (Math.abs(dx) < drempel && Math.abs(dy) < drempel) return 'onbekend'
  return Math.abs(dx) > Math.abs(dy) ? 'horizontaal' : 'verticaal'
}

/** Hoe ver de kaart meeschuift: alleen naar rechts, begrensd tot de kaartbreedte. */
export function swipeVerschuiving(dx: number, breedte: number): number {
  if (dx <= 0) return 0
  return Math.min(dx, Math.max(0, breedte))
}

/** Aantal pixels waarboven loslaten de actie start. */
export function swipeActiveerDrempel(breedte: number): number {
  return Math.max(SWIPE_ACTIVEER_MIN_PX, Math.round(Math.max(0, breedte) * SWIPE_ACTIVEER_FRACTIE))
}

/** Start loslaten bij deze horizontale beweging de actie? */
export function swipeActiveert(dx: number, breedte: number): boolean {
  return swipeVerschuiving(dx, breedte) >= swipeActiveerDrempel(breedte)
}
